import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Icon from '../Icon'

import { capitalizeFirstLetter } from 'utils/string'

export type Crumb = {
  label: string
  url?: string
  onClick?: () => void
}

type Props = {
  crumbs: Crumb[]
}

const Breadcrumbs = ({ crumbs }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Container>
      {crumbs.map(
        (i, index) =>
          i.label && (
            <Item key={index}>
              <span
                data-url={i.url ?? ''}
                onClick={() => {
                  i.onClick?.()
                  i.url && navigate(i.url)
                }}
              >
                {capitalizeFirstLetter(t(i.label))}
              </span>
              {crumbs.length - 1 !== index && <Icon icon={['far', 'angle-right']} mx="8px" />}
            </Item>
          ),
      )}
    </Container>
  )
}

const Container = styled.ul`
  align-items: center;
  display: flex;
  user-select: none;
`

const Item = styled.li`
  ${(p) =>
    p.theme.font({
      size: 16,
      weight: 'bold',
    })}
  display: flex;
  align-items: center;

  * {
    color: ${(p) => p.theme.colors.gray5};
  }

  &:last-child * {
    color: ${(p) => p.theme.colors.defaultText};
  }

  span[data-url]:not([data-url='']):hover {
    cursor: pointer;
    color: ${(p) => p.theme.colors.blue1};
  }
`

export default Breadcrumbs
